import { render, staticRenderFns } from "./modifyPrice.vue?vue&type=template&id=bcc9d6b8&scoped=true"
import script from "./modifyPrice.vue?vue&type=script&lang=js"
export * from "./modifyPrice.vue?vue&type=script&lang=js"
import style0 from "./modifyPrice.vue?vue&type=style&index=0&id=bcc9d6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc9d6b8",
  null
  
)

export default component.exports